import $ from "jquery";

class TitleWithVertical {
  constructor (uuid) {
    const $handle = $(`#${uuid}`).find('.itbl-title-with-vertical-handle')
    const $dropdown = $(`#${uuid}`).find('.itbl-title-with-vertical-dropdown')
    const $dropdownContainer = $handle.find('.itbl-title-with-vertical-dropdown-container')
    const options = $dropdown.find('li')

    $dropdown.remove()
    $dropdownContainer.append($dropdown)

    const dropdownHeight = $dropdown[0].getBoundingClientRect().height + 'px';

    $dropdown.css({ top: '100%', height: 0, visibility: "visible" })

    $handle.on('mouseenter', () => $dropdown.css({ height: dropdownHeight }))

    $handle.on('mouseleave', () => $dropdown.css({ height: 0 }))

    options.on('click', function () {
      const $option = $(this)
      const vertical = $option.attr('data-vertical')

      //$('.itbl-title-with-vertical-handle-text').text($option.text())

      $('[data-verticalcontent]').each(function () {
        const isThisVertical = $(this).attr('data-verticalcontent') === vertical

        if (isThisVertical) {
          $(this).removeClass('hide')
        } else {
          $(this).addClass('hide')
        }
      })

      $(document).trigger("verticalChanged", [vertical]);
    })
  }
}

$(document).ready(() => {
  $(".itbl-b-title-with-vertical").each((i, e) => {
    new TitleWithVertical($(e).attr("id"));
  });
});
